import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithoutAuthorization, postApiWithAuthorization } from "../ApiMethod/ApiMethod";

const base = `${BaseUrl}`
export const PujaKitSubscriptionPlanList = async () => {
    const url = `${base}/PujaKitSubscriptionPlanList`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};

export const UserWisePujaKitSubscriptionPlanBookingListByMonth = async (ID) => {
    const url = `${base}/UserWisePujaKitSubscriptionPlanBookingListByMonth?PKSubPBookID=${ID}`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};